module.exports = __webpack_public_path__ + "assets/img/00001.80f00f32.png";